import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=04758e70&"
import script from "./AppSelect.js?vue&type=script&lang=js&"
export * from "./AppSelect.js?vue&type=script&lang=js&"
import style0 from "./AppSelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports